import { PropsWithChildren, useCallback } from "react";

import { AuthKitProvider } from "@workos-inc/authkit-react";

import {
  IS_DEVELOPMENT,
  IS_LOCAL,
  WORKOS_API_HOSTNAME,
  WORKOS_CLIENT_ID,
  WORKOS_REDIRECT_URI,
} from "@/constants";

const WorkOSAuthProvider = ({ children }: PropsWithChildren) => {
  const DEV_MODE = IS_DEVELOPMENT || IS_LOCAL;

  const handleRedirectCallback = useCallback(
    (params: { state: Record<string, unknown> | null }) => {
      const returnTo = params.state?.returnTo;
      if (typeof returnTo === "string" && returnTo !== window.location.pathname) {
        if (returnTo.includes("?")) {
          window.location.replace(returnTo);
        } else {
          window.history.replaceState(null, "", returnTo);
        }
      }
    },
    [],
  );

  return (
    <AuthKitProvider
      clientId={WORKOS_CLIENT_ID}
      apiHostname={WORKOS_API_HOSTNAME}
      redirectUri={WORKOS_REDIRECT_URI}
      refreshBufferInterval={15}
      onRedirectCallback={handleRedirectCallback}
      devMode={DEV_MODE}
    >
      {children}
    </AuthKitProvider>
  );
};

export default WorkOSAuthProvider;
